import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';
const suburbs = ['Balcatta', 'Stirling', 'Karrinyup', 'Innaloo', 'Scarborough', 'Doubleview', 'Osborne Park', 'Tuart Hill', 'Yokine', 'Mount Lawley', 'Maylands', 'Inglewood', 'Bayswater', 'Morley', 'Dianella', 'Carine', 'Duncraig', 'Greenwood', 'Kingsley', 'Padbury', 'Hillarys', 'Sorrento', 'Marmion', 'Mullaloo', 'Joondalup', 'Currambine', 'Wanneroo', 'Subiaco', 'Cottesloe', 'Nedlands', 'Perth CBD'];
export function SuburbsMap() {
  return <section className="bg-cream py-20 md:py-28" data-id="element-731">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-732">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start" data-id="element-733">
          {/* Left: Map */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="lg:col-span-5" data-id="element-734">
            <div className="relative aspect-square lg:aspect-[4/5] rounded-2xl overflow-hidden bg-brand border border-stone-200 shadow-xl" data-id="element-735">
              <iframe title="Langler Air Balcatta location" src="https://www.openstreetmap.org/export/embed.html?bbox=115.7100%2C-32.0500%2C115.9300%2C-31.7000&amp;layer=mapnik&amp;marker=-31.8753%2C115.8200" className="w-full h-full opacity-95" loading="lazy" aria-label="Map showing Langler Air in Balcatta, Perth" data-id="element-736"></iframe>

              <div className="absolute bottom-5 left-5 right-5 bg-white rounded-2xl p-5 shadow-2xl border border-stone-200" data-id="element-737">
                <div className="flex items-start gap-3" data-id="element-738">
                  <div className="w-10 h-10 rounded-full bg-brand text-white flex items-center justify-center flex-shrink-0" data-id="element-739">
                    <MapPin size={16} data-id="element-740" />
                  </div>
                  <div data-id="element-741">
                    <div className="text-base font-bold tracking-tight text-ink leading-tight" data-id="element-742">
                      Langler Air Workshop
                    </div>
                    <div className="text-sm text-stone-600 mt-1 leading-snug" data-id="element-743">
                      Unit 2/3 Cressall Rd, Balcatta WA 6021
                    </div>
                    <a href="https://maps.google.com/?q=Unit+2%2F3+Cressall+Rd%2C+Balcatta+WA+6021" target="_blank" rel="noopener noreferrer" className="inline-block mt-2 text-xs font-bold text-brand hover:underline underline-offset-2" data-id="element-744">
                      Open in Google Maps →
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Right: Suburbs grid */}
          <div className="lg:col-span-7" data-id="element-745">
            <div className="text-xs font-semibold uppercase tracking-widest text-brand mb-4" data-id="element-746">
              Where We Install
            </div>
            <h2 className="text-2xl md:text-4xl font-bold tracking-tight text-ink leading-tight mb-6" data-id="element-747">
              All Perth metro from Balcatta.
            </h2>
            <p className="text-lg text-stone-600 leading-relaxed mb-8 max-w-lg" data-id="element-748">
              We install across all of Perth metropolitan area from our Balcatta
              workshop. We also travel for ducted jobs across WA, just ask.
            </p>

            <motion.div initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="grid grid-cols-2 sm:grid-cols-3 gap-x-3 gap-y-2" data-id="element-749">
              {suburbs.map((suburb, i) => <div key={i} className={`text-sm flex items-center gap-2 py-1 ${suburb === 'Balcatta' ? 'font-bold text-brand' : 'text-stone-700'}`} data-id="element-750">
                  <span className={`w-1.5 h-1.5 rounded-full ${suburb === 'Balcatta' ? 'bg-brand' : 'bg-stone-300'}`} data-id="element-751"></span>
                  {suburb}
                  {suburb === 'Balcatta' && <span className="text-[10px] uppercase tracking-wider font-semibold text-accent ml-1" data-id="element-752">
                      base
                    </span>}
                </div>)}
            </motion.div>

            <div className="mt-8 p-5 bg-white border border-stone-200 rounded-2xl flex items-start gap-3 shadow-md" data-id="element-753">
              <div className="w-2 h-2 rounded-full bg-success mt-2 flex-shrink-0 animate-pulse" data-id="element-754"></div>
              <p className="text-sm text-stone-700 leading-relaxed" data-id="element-755">
                <strong className="text-ink" data-id="element-756">Not on the list?</strong> Call us.
                We have installed everywhere from Two Rocks to Mandurah, and
                travel further for ducted jobs across regional WA.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}